module.exports = __webpack_public_path__ + "img/img_home_panel_2.aea2b2c7.jpg";